import { $GQL } from '@GQL/index';

export async function getAPIKeys() {
	const query = `
        query GetAPIKeys {
            apiKeys: apiKeysV2{
                id
                name
                key
                owner_id
                owner_type
                account_name
                mpid
                role_id
                status
            }
        }
    `;

	return (await $GQL.request(query)).apiKeys;
}
